import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../utils/authContext";
import { BounceLoader } from "react-spinners";

export default function StartupProtectedRoutes() {
  const {
    initialized,
    isStartupLoggedIn,
    subscription,
    loadingSubscription,
    subscriptionError
  } = useAuth();

  const location = useLocation();


  // Read token from localStorage
  const token = localStorage.getItem("Startuptoken");

  // Check if this is demo user
  const isDemoUser = token === "DEMO_TOKEN";

  if (!initialized) return null;

  // Treat demo user as logged in
  const effectiveLoggedIn = isStartupLoggedIn || isDemoUser;

  if (!effectiveLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // DEMO USER → skip subscription checks
  if (isDemoUser) {
    return <Outlet />;
  }

  // Normal user → validate subscription
  if (loadingSubscription) {
    return (
      <div className="flex justify-center items-center h-screen">
        <BounceLoader size={50} />
        <span className="ml-2">Loading subscription…</span>
      </div>
    );
  }

  const expireMs = subscription
    ? new Date(subscription.createdAt).getTime() +
    subscription.tenure * 24 * 60 * 60 * 1000
    : 0;

  const noSub =
    subscriptionError ||
    !subscription ||
    Date.now() > expireMs;

    
  const ALLOWED_WITHOUT_SUBSCRIPTION = [
    "/startupmeetings",
  ];

  if (
    noSub &&
    !ALLOWED_WITHOUT_SUBSCRIPTION.includes(location.pathname)
  ) {
    return <Navigate to="/admin-setting" replace />;
  }


  return <Outlet />;
}
